export const ALL_FAQ_REQUEST = "ALL_FAQ_REQUEST";
export const ALL_FAQ_SUCCESS = "ALL_FAQ_SUCCESS";
export const ALL_FAQ_FAIL = "ALL_FAQ_FAIL";
